// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1D-1v","amount":"Amount_amount__2m0tZ","tip":"Amount_tip__1ONaP","tipHeader":"Amount_tipHeader__2CwSO","tipsWrap":"Amount_tipsWrap__3yeh3"};